import React, {useState, useEffect} from "react";
import {useDataWithRoute, useTitleFromComponent} from "../../../../utils/hooks";
import {useVsiAppContext} from "../../../../stores/VsiApp";
import {useSearchParams} from "react-router-dom";
import {hostPerformanceDetail} from "../../../../utils/gridColumnDefs/hosts/hostTrends";
import {VsiBubble, VsiH4,} from "../../../../styled/App.styled";
import Grid from "../../../../components/Grid";
import FlexChart from "../../../../components/FlexChart";
import {formatDualAxisStockChartConfig} from "../../../../utils/Helpers";
import {Card} from "reactstrap";

export default function HostLunPerformanceDetail({context, title}) {
    useTitleFromComponent(`${context} / ${title}`);
    const { theme, client, periodId } = useVsiAppContext();

    const [searchParams] = useSearchParams();

    const [chartSeries, setChartSeries] = useState([]);
    const [chartCategories, setChartCategories] = useState([]);

    const encodedDevice = encodeURIComponent(searchParams.get('device_name'));
    const encodedHost = encodeURIComponent(searchParams.get('host_name'));
    const decodedHost = decodeURIComponent(encodedHost);

    const [data] = useDataWithRoute(`/api/v6/report/host_lun_performance_detail_proc?client_id=${client.clientId}&host_name=${encodedHost}&device_name=${encodedDevice}&period_id=${periodId}`);

    useEffect(() => {
        handleStateWithData(data?.recordsets?.[0] || []);
    }, [data, searchParams]);

    const handleStateWithData = data => {
        const allSeriesData = formatDualAxisStockChartConfig(data || [], [
            {
                type: "column",
                name: 'Read IO',
                field: 'read_io',
                yAxis: 0
                // zoneAxis: 'x',
            },
            {
                type: "column",
                name: 'Write IO',
                field: 'write_io',
                yAxis: 0
                // zoneAxis: 'x',
            },
            {
                type: "spline",
                name: 'Latency (ms)',
                field: 'latency',
                yAxis: 1
                // dashStyle: 'dash',
                // disableMarker: true,
            }
        ], 'lun_name');
        setChartSeries(allSeriesData.series);
        setChartCategories(allSeriesData.categories);
    }

    const filterChanged = (eventData) => {
        let rowData = [];
        eventData.api.forEachNodeAfterFilter(node => rowData.push(node.data));
        handleStateWithData(rowData || []);
    };

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Host LUN Performance - {decodedHost || 'N/A'}</VsiH4>
        <VsiBubble autobotName='StackedLineColumnChart'>
            <FlexChart series={chartSeries}
                       constructorType={'chart'}
                       disableRangeSelector={true}
                       navDisabled={true}
                       height={600}
                       config={{
                           colors: ["#1E90FF", "#000069", "#228B22"],
                           yAxis: [
                               {
                                   title: {
                                       text: 'IOPS'
                                   },
                                   opposite: false
                               },
                               {
                                   title: {
                                       text: 'Latency (ms)'
                                   },
                                   opposite: true
                               },
                           ]
                       }}
                       categories={chartCategories}/>
        </VsiBubble>
        <VsiBubble>
            <Grid data={data?.recordsets?.[0] || []}
                  filterChanged={filterChanged}
                  columnDefs={hostPerformanceDetail}/>
        </VsiBubble>
    </Card>
}
